


















































































































































































































































































































import { VueConstructor } from 'vue';
import {
	computed,
	defineComponent,
	PropType,
	Ref,
	ref,
	watch,
} from '@vue/composition-api';
import addDays from 'date-fns/addDays';
import addMinutes from 'date-fns/addMinutes';
import parse from 'date-fns/parse';
import TimedRightLogo from '@front-app/components/TimedRightLogo.vue';
import CtaButton from '@front-app/components/buttons/CtaButton.vue';
import { ButtonPalettes } from '@front-app/components/buttons/palettes';
import ChevronIcon from '@front-app/components/icons-old/ChevronDown.vue';
import SimpleCard from '@front-app/components/cards/SimpleCard.vue';
import ErrorCard from '@front-app/components/cards/state/ErrorCard.vue';
import SuccessCard from '@front-app/components/cards/state/SuccessCard.vue';
import { Size, Spacing } from '@front-app/components/constants';
import SimpleDropdown from '@front-app/components/dropdowns/SimpleDropdown.vue';
import EmailListInput from '@front-app/components/form/EmailListInput.vue';
import TrForm from '@front-app/components/form/Form.vue';
import FormError from '@front-app/components/form/FormError.vue';
import FormLabel from '@front-app/components/form/FormLabel.vue';
import FormSection from '@front-app/components/form/FormSection.vue';
import { v } from '@front-app/components/form/validation/useValidation';
import { required, inRange, isDateOrLater } from '@front-app/components/form/validation/validators';
import BasicTextEditor from '@front-app/components/inputs/BasicTextEditor.vue';
import RadioButton from '@front-app/components/inputs/RadioButton.vue';
import BaseDivider from '@front-app/components/layouts/BaseDivider.vue';
import SlidingPanel from '@front-app/components/modals/SlidingPanel.vue';
import TimePicker from '@front-app/components/TimePicker.vue';
import { useAsyncModal } from '@front-app/hooks/useAsyncModal';
import { useAsyncStatus, useStatus } from '@front-app/hooks/useAsyncStatus';
import { useFocusFirstInvalidField } from '@front-app/hooks/useFocusFirstInvalidField';
import { AllButtonOption, InviteeButtonOption } from '@front-app/modules/group/components/admin/inviteesListModal';
import { inviteCampaignEmailStorage } from '@front-app/modules/group/hooks/useInviteCampaignEmailStorage';
import {
	GroupInvitationCampaign,
	UpdateInvitationCampaignRequest,
	InvitationCampaignInvitee,
	InviteeStatus,
	InvitationInviteType,
	UpsertInvitationCampaignInvite,
	InvitationCampaignInvite,
	InviteeCounts,
} from '@front-app/services/GroupInvitationCampaignApi/model';
import { UserRole } from '@front-app/services/UserApi/UserModel';
import { GroupsLogoStore } from '@front-app/store/singletons/Groups';
import { InvitationCampaignsStore } from '@front-app/store/singletons/InvitationCampaigns';
import { InvitationCampaignInviteesStore } from '@front-app/store/singletons/InvitationCampaignInvitees';
import { toDatetimeLocal } from '@front-app/util/format';
import { isNonValidEmailAddress } from '@front-app/util/validate';

const importInviteesListModal = () => import(/* webpackChunkName: "invitees-list" */ '@front-app/modules/group/components/admin/InviteesListModal.vue')
	.then((_) => _.default as VueConstructor);

const importInviteeInvitesModal = () => import(/* webpackChunkName: "invitees-list" */ '@front-app/modules/group/components/admin/InviteeInvitesModal.vue')
	.then((_) => _.default as VueConstructor);

const importEditGroupInviteModal = () => import(/* webpackChunkName: "edit-group-invite" */ '@front-app/modules/group/components/admin/EditGroupInviteModal.vue')
	.then((_) => _.default as VueConstructor);

export default defineComponent({
	components: {
		BaseDivider,
		BasicTextEditor,
		ChevronIcon,
		CtaButton,
		EmailListInput,
		ErrorCard,
		FormError,
		FormLabel,
		FormSection,
		RadioButton,
		SimpleCard,
		SimpleDropdown,
		SlidingPanel,
		SuccessCard,
		TimedRightLogo,
		TimePicker,
		TrForm,
	},
	props: {
		groupId: {
			type: String,
			required: true,
		},
		campaign: {
			type: Object as PropType<GroupInvitationCampaign>,
			required: true,
		},
		inviteeCounts: {
			type: Object as PropType<InviteeCounts>,
			required: true,
		},
	},
	setup(props) {
		const groupLogo = computed(() => GroupsLogoStore.get(props.groupId));

		// Invitees
		const emailAddressText = ref('');

		// Check the local storage if there are invitee emails to add
		const storedEmailAddresses = computed(() => inviteCampaignEmailStorage.get());
		watch(storedEmailAddresses, (curr, prev) => {
			if (!curr || curr === prev) {
				return;
			}

			if (emailAddressText.value) {
				emailAddressText.value = `${emailAddressText.value}, ${storedEmailAddresses.value}`;
			} else {
				emailAddressText.value = storedEmailAddresses.value;
			}
			inviteCampaignEmailStorage.set('');
		}, { immediate: true });

		const emailAddressList = computed(() => emailAddressText.value
			.split(',')
			.map((val) => val.trim())
			.filter(Boolean));
		const badEmailAddresses = computed(() => emailAddressList.value.filter(isNonValidEmailAddress));
		const duplicateEmailAddresses = computed(() => {
			const uniqueEmailsAddress: string[] = [];
			const duplicateAddresses: string[] = [];
			emailAddressList.value.forEach((emailAddress) => {
				if (uniqueEmailsAddress.includes(emailAddress) && !duplicateAddresses.includes(emailAddress)) {
					duplicateAddresses.push(emailAddress);
				} else {
					uniqueEmailsAddress.push(emailAddress);
				}
			});
			return duplicateAddresses;
		});
		// END Invitees

		// Invitees list modal
		const selectedInviteesStatus: Ref<InviteeButtonOption> = ref(InviteeStatus.ACTIVE);

		const inviteesListModal = useAsyncModal('invitees-list', importInviteesListModal);

		const openInviteesListModal = (statuses: InviteeButtonOption) => {
			selectedInviteesStatus.value = statuses;
			inviteesListModal.showModal();
		};
		// END Invitees list modal

		// Invitee invites modal
		const selectedInvitee = ref({} as InvitationCampaignInvitee);
		const inviteeInvitesModal = useAsyncModal('invitee-invites', importInviteeInvitesModal);
		const openInviteeInvitesPanel = (invitee: InvitationCampaignInvitee) => {
			selectedInvitee.value = invitee;
			inviteeInvitesModal.showModal();
		};
		// END Invitee invites modal

		// Send time for invitations
		const initialSendTime = ref(toDatetimeLocal(addMinutes(Date.now(), 10)));
		const minimumInitialTime = ref(toDatetimeLocal(Date.now()));
		const maximumInitialTime = ref(toDatetimeLocal(addDays(Date.now(), 1)));

		const getInitialSendTime = () => parse(initialSendTime.value, "yyyy-MM-dd'T'HH:mm", new Date()).toISOString();
		// END Send time for invitations

		// Edit invitation modal
		const invitationType = ref(InvitationInviteType.INITIAL);

		const editGroupInviteModal = useAsyncModal('edit-group-invite', importEditGroupInviteModal);

		const openEditInviteModal = (type: InvitationInviteType) => {
			invitationType.value = type;
			editGroupInviteModal.showModal();
		};

		const toUpsertRequest = (input: InvitationCampaignInvite): UpsertInvitationCampaignInvite => ({
			subject: input.subject,
			topHtml: input.topHtml,
			bottomHtml: input.bottomHtml,
		});

		const invitationToEdit = computed(() => {
			if (invitationType.value === InvitationInviteType.INITIAL) {
				return toUpsertRequest(props.campaign.invites.initial);
			}
			return toUpsertRequest(props.campaign.invites.reminder);
		});
		// END Edit invitation modal

		// Validation
		const validation = v({
			emails: {
				value: emailAddressList,
				rules: [required()],
			},
			duplicateEmails: {
				value: computed(() => duplicateEmailAddresses.value.length),
				rules: [inRange(0, 0)],
			},
			initialSendTime: {
				value: initialSendTime,
				rules: [required(), isDateOrLater(new Date())],
			},
		});

		const { focusFirstInvalid } = useFocusFirstInvalidField({
			containerSelector: '#invitation-campaign-form',
			scrollConfig: { block: 'center' },
		});
		// END Validation

		// Submission
		const scheduleStatus = useAsyncStatus();
		const {
			isError,
			isSuccess,
			isLoading,
		} = useStatus(computed(() => scheduleStatus.status.value));

		const scheduleCampaign = async () => {
			validation.validate();
			if (!validation.isValid.value) {
				focusFirstInvalid();
				return;
			}

			const recipientsList = emailAddressList.value.map((email) => ({
				email,
				role: UserRole.MEMBER,
			}));

			const payload: UpdateInvitationCampaignRequest = {
				name: 'Invite Campaign',
				reminderSendHour: 8,
				initialSendTime: getInitialSendTime(),
				newRecipients: recipientsList,
			};

			await scheduleStatus.track(InvitationCampaignsStore.updateInvitationCampaign(props.groupId, props.campaign.id, payload));

			if (isSuccess.value) {
				emailAddressText.value = '';
				initialSendTime.value = toDatetimeLocal(addMinutes(Date.now(), 10));

				InvitationCampaignInviteesStore.fetchInviteeCounts(
					props.groupId,
					props.campaign.id,
				);
			}
		};
		// END Submission

		return {
			groupLogo,
			// Invitees
			emailAddressText,
			badEmailAddresses,
			duplicateEmailAddresses,
			// Invitees list modal
			InviteeStatus,
			AllButtonOption,
			selectedInviteesStatus,
			openInviteesListModal,
			isInviteesListModalVisible: inviteesListModal.isModalVisible,
			inviteesListModalView: inviteesListModal.modalView,
			inviteesListModal,
			// Invitee invites modal
			selectedInvitee,
			openInviteeInvitesPanel,
			isInviteeInvitesModalVisible: inviteeInvitesModal.isModalVisible,
			inviteeInvitesModalView: inviteeInvitesModal.modalView,
			inviteeInvitesModal,
			// Invitation contents
			invitationToEdit,
			// Send time for invitations
			initialSendTime,
			minimumInitialTime,
			maximumInitialTime,
			// Validation
			validation,
			// Invite time dropdowns
			dropdownButtonSize: Size.SMALL,
			// Edit Invites modal
			InvitationInviteType,
			invitationType,
			openEditInviteModal,
			isEditGroupInviteModalVisible: editGroupInviteModal.isModalVisible,
			editGroupInviteModalView: editGroupInviteModal.modalView,
			editGroupInviteModal,
			// Submission
			scheduleCampaign,
			isError,
			isSuccess,
			isLoading,
			// Util
			ButtonPalettes,
			Size,
			Spacing,
		};
	},
});
